// extracted by mini-css-extract-plugin
export var label = "_g5-2";
export var slideContainer = "_g5-0";
export var slider = "_g5-1";